import { action } from 'mobx'
import type {
  FutureTaxCreditTaxRefundDeliveryMethod,
  TaxRefundDeliveryMethod,
} from './TaxRefundDeliveryMethod'
import { validationContext } from 'validx'

/**
 * View model for editing a future tax credit delivery method.
 */
export class FutureTaxCreditDeliveryMethodEditorViewModel {
  /**
   * The type of the delivery method.
   */
  readonly type = 'FutureTaxCredit' as const

  /**
   * Validation context for the view model (always valid).
   */
  readonly validation = validationContext(this, {})

  /**
   * Resets the state of the view model.
   */
  @action.bound
  reset(_method?: FutureTaxCreditTaxRefundDeliveryMethod) {
    // No state to reset
    this.validation.reset()
  }

  /**
   * Maps the state of the VM to {@link FutureTaxCreditTaxRefundDeliveryMethod}.
   */
  toDeliveryMethod(): TaxRefundDeliveryMethod {
    return { type: 'FutureTaxCredit' }
  }
}
